<div class="modal fade" id="separationResultModal" tabindex="-1" aria-labelledby="separationResultModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header border-0 pb-0 position-relative">
        <button type="button" class="btn-close position-absolute top-0 end-0 m-3" (click)="close()"></button>
      </div>

      <div class="modal-body text-center pt-2 px-4 pb-0">
        <h5 class="fw-bold mb-2">¡Viáticos separados con éxito!</h5>
        <p class="text-muted" style="font-size: 0.9rem; line-height: 1.5;">
          Deseas unificar los viáticos de este servicio con otro servicio
          o que permanezca con viáticos únicos
        </p>
      </div>

      <div class="modal-footer border-0 justify-content-center gap-3 pt-3 pb-4">
        <button type="button" class="btn btn-outline-primary sep-btn" (click)="onUnify()">Unificar viáticos</button>
        <button type="button" class="btn btn-primary sep-btn" (click)="onAlone()">Viático único</button>
      </div>

    </div>
  </div>
</div>
